// Template: resources/views/_components/admin/media-editor.blade.php
import Modal from './Modal';

export default {

    name: "MediaEditor",

    components: { Modal },

    props: {
        renderTemplate: {default: true},
        transition: {default: 'fade'},
        medium: null,
        thumb: {type: String, default: 'square'} // or original
    },

    data() {
        return {
            internalMedium: {
                title: '',
                description: '',
                alt_text: ''
            },
			exists: true,
            showModal: false,
            isUpdating: false,
            isDeleting: false,
        }
    },

    created() {
        const allowed = ['title', 'description', 'alt_text', 'file_name']

        this.internalMedium = Object.keys(this.medium)
        .filter(key => allowed.includes(key))
        .reduce((obj, key) => {
            obj[key] = this.medium[key];
            return obj;
        }, {});
    },

    computed: {
        mediumUrl() {
            if (this.medium.type == 'icon') {
                return 'data:image/svg+xml;utf8,' + this.medium.content;
            } else {
                return this.medium.url;
            }
        },

        mediumThumbnail() {
            if (this.medium.type == 'icon') {
                return 'data:image/svg+xml;utf8,' + this.medium.content;
            } else {
                return this.thumb == 'square' ? this.medium.thumb : this.medium.url;
            }
        }
    },

    methods: {
        update() {
            this.isUpdating = true;
            this.$bus.$emit('update-medium', {
                id: this.medium.id,
                data: this.internalMedium
            });
        },

        remove() {
            this.isDeleting = true;
            this.$bus.$emit('delete-medium', this.medium);
        }
    }
};
